
<template>
    <div class="mains" v-if="isShow">
        <div class="model_content">
            <div class="title">
                <span class="network">活畜档案</span>
                <i @click="hideModel" width="0.29rem" height="0.29rem"
                    style="cursor: pointer;color:#FFFFFF;font-size: 0.4rem;" class="el-icon-close"></i>
            </div>
            <div class="box">
                <div class="swith-box" v-for="(item, i) in headList" :key="i" :class="{ active: active == i }"
                    @click="switchBtn(i)">
                    {{ item }}
                </div>
            </div>
            <div class="info" v-if="active == 0">
                <img src="../../assets/niu1.jpg" alt="">
                <div class="r-info" style="margin-left: .8rem;">
                    <div class="row-info">
                        <span>耳标编号：XMB00000000</span>
                        <span>活畜类别：西门塔尔-基础母牛</span>
                        <span>出生日期：2023-12-20</span>
                        <span>体重：<span class="number">150</span>kg</span>
                        <span>外貌特征：红花白</span>
                        <span>引进日期：2022-10-10</span>
                        <span>父亲编号：1254789654(耳标)</span>
                    </div>
                    <div class="row-info" style="margin-left: 2rem;">
                        <span>芯片编号：00000000</span>
                        <span>活畜级别：二级</span>
                        <span>出生地：内蒙古-鄂尔多斯-伊金霍洛旗</span>
                        <span>绒直径：<span class="number">150</span>cm</span>
                        <span>配种月龄：12月</span>
                        <span>出栏日期：2022-10-10</span>
                        <span>母亲编号：02365410(电子项圈)</span>
                    </div>
                </div>
            </div>
            <div class="center" v-if="active != 0">
                <!-- <dv-scroll-board :config="config" @mouseover='mouseover'
                    style="width:100%;height:6.6rem;margin-top: .25rem;" /> -->
                <span class="notHave" v-if="config.data.length <= 0">暂无数据</span>
                <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize" @pagination="getList" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            isShow: false,
            active: 0,
            headList: ['基础信息', '绒质检测记录', '免疫/检疫记录', '疫病/治病记录', '体重记录', '繁育记录'],
            config: {
                data: []
            },
            config1: {
                header: ['直径(um)', '直径标准差', '长度(mm)', '长度标准差', '长度变异系数(%)', '测量数', '测量日期'],
                data: [
                    [10000, '类别sdfdfdfdf地方大师傅第三方的是多少', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                    [10000, '类别', '羊毛', 4, 6, 3, 5],
                ],
                align: ['right', 'right', 'right', 'right', 'right', 'right', 'center'],
                // columnWidth: [200, 200, 200, 200, 200, 200, 200],
                headerHeight: 40,
                rowNum: 10,
                waitTime: 2000
            },
            config2: {
                header: ['检疫/免疫日期', '免疫/检疫项目', '项目名称', '剂量', '检疫/免疫方式', '检疫/免疫结果', '检疫/免疫机构', '操作人员', '备注说明'],
                data: [
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                    [10000, '类别', '羊毛', 4, 6, 3, 5, 'ewr', 'egf'],
                ],
                align: ['left', 'left', 'left', 'center', 'left', 'left', 'left', 'left', 'left'],
                // columnWidth: [200, 200, 200, 200, 200, 200, 200],
                headerHeight: 40,
                rowNum: 10,
                waitTime: 2000
            },
            // 总条数
            total: 2,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
            },
        };
    },
    components: {
    },
    // props: {
    //     animalRecord: {
    //         type: Object
    //     },
    // },
    watch: {},
    mounted() {
    },
    created() {

    },
    filters: {
    },
    methods: {
        // 鼠标移入全部显示
        mouseover() {
            var divs = [...document.querySelectorAll('.center .row-item')]
            divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },
        getList() {
        },
        switchBtn(val) {
            this.active = val
            if (val == 0) return
            if (val == 1) this.config = this.config1
            if (val == 2) this.config = this.config2
        },
        showModel() {
            this.NoScrolling()
            this.isShow = true;
        },
        hideModel() {
            this.isShow = false;
            this.scrolling()
        },
    },
};
</script>
<style lang="scss" scoped>
// /*解决固定列遮盖底部滚定条导致滚动条无法滚动的问题*/
// ::v-deep .el-table__body-wrapper {
//     z-index: 2
// }

// ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
//     height: 10px;
// }

// // ::v-deep .el-scrollbar__wrap {
// //     width: 20px !important;
// //     background-color: red !important;
// //     height: 20px !important;
// //     color: yellow !important;
// //     overflow-x: scroll !important;
// // }
// /* 滚动槽 */
// ::v-deep ::-webkit-scrollbar-track {
//     // -webkit-box-shadow: red;
//     background: rgba(28, 71, 163, 0.2);
//     border-radius: 0,
// }
// /* 滚动条滑块 */
// ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
//     background: #2C76FE;
//     border-radius: 0;
// }
// ::v-deep ::-webkit-scrollbar-button {
//     background: #18418e;
// }
.mains {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.74);
    opacity: 1;

    .model_content {
        position: relative;
        width: 16.25rem;
        height: 9.63rem;
        background: #081D31;
        ;
        border-radius: .1rem;
        border: 0.01rem solid #1B475B;
        padding: .28rem 0.34rem 0;
        z-index: 999;

        .box {
            margin-top: .5rem;
            display: flex;

            .swith-box {
                width: 1.5rem;
                height: 0.38rem;
                background: rgba(25, 236, 255, 0.2);
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                margin-left: .45rem;
                font-size: 0.15rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #19ECFF;
                line-height: 0.38rem;
                text-align: center;
                cursor: pointer;
            }

            .swith-box:nth-child(1) {
                margin-left: 0rem;
            }
        }

        .info {
            display: flex;
            align-items: center;
            margin-top: 1.25rem;

            img {
                display: block;
                width: 3.75rem;
                height: 3.75rem;
                border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
            }

            .r-info {
                display: flex;
                justify-content: flex-start;
                flex: 1;
                // margin-left: .29rem;

                .row-info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 0.18rem;
                    font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                    font-weight: 400;
                    color: #FFFFFF;

                    span {
                        padding-top: .41rem;
                    }

                    span:nth-child(1) {
                        padding-top: 0;
                    }
                }

                .number {
                    color: #19ECFF;
                    padding: 0;
                }
            }
        }

        .center {
            display: flex;
            flex-direction: column;
        }

        .notHave {
            position: absolute;
            top: 50%;
            left: 45%;
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
        }

        .footer {
            position: relative;
            margin-top: .94rem;
        }
    }

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .network {
            font-size: 0.23rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
        }
    }

    .active {
        background: rgba(25, 236, 255, 1) !important;
        color: #032929 !important;
    }
}

.pagination-container {
    background: transparent;
    display: flex;
    justify-content: flex-end;
} 

::v-deep .el-pagination__total {
    display: none !important;
}

::v-deep .el-input--mini {
    display: none !important;
}

::v-deep .el-pagination__jump {
    display: none !important;
}

::v-deep .btn-prev {
    background: transparent !important;
    color: #FFFFFF !important;
}

::v-deep .btn-next {
    background: transparent !important;
    color: #FFFFFF !important;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #19ECFF !important;
    color: #032929 !important;
}

::v-deep .el-pagination.is-background .el-pager li {
    background: transparent !important;
    color: #FFFFFF !important;
}</style>